module.exports = __webpack_public_path__ + "img/product_85.7280cfb.webp";